// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lilligant: PokeData = {
  "id": 549,
  "name": "lilligant",
  "height": 11,
  "weight": 163,
  "base_experience": 168,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "stun-spore",
    "sleep-powder",
    "petal-dance",
    "giga-drain",
    "charm",
    "synthesis",
    "sunny-day",
    "helping-hand",
    "teeter-dance",
    "aromatherapy",
    "magical-leaf",
    "energy-ball",
    "leaf-storm",
    "quiver-dance",
    "entrainment",
    "after-you",
    "petal-blizzard"
  ],
  "moves": [
    "stun-spore",
    "synthesis",
    "sunny-day",
    "aromatherapy",
    "energy-ball",
    "branch-poke",
    "flower-rush",
    "overgrowth",
    "frenzy-plant",
    "bullet-seed",
    "leaf-tornado",
    "vine-whip",
    "grassy-terrain"
  ],
  "evolution_chain": {
    "id": 279,
    "item": null,
    "species": [
      {
        "name": "petilil",
        "order": 549,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lilligant",
        "order": 550,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 548,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sun-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 106,
    "speed": 132,
    "ability_power": 161
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
